import { StepFunctionTaskRequestSchema } from '../request.js';
import { PhotoReportInputSchema } from './photoReportInput.js';
export const CompressPhotoReportInputSchema = PhotoReportInputSchema;
export const CompressPhotoReportRequestSchema = StepFunctionTaskRequestSchema.extend({
    input: CompressPhotoReportInputSchema,
});
